/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import PayWithAlipayDetailsComponent from './payWithAlipay.component';

const PayWithAlipayModule = angular.module('tinaba.components.services.payWithAlipay', [
    uiRouter
])
.config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.payWithAlipay', {
        url: '/payWithAlipay',
        template: '<pay-with-alipay-details></pay-with-alipay-details>'
    });
})
.component('payWithAlipayDetails', PayWithAlipayDetailsComponent);

export default PayWithAlipayModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/payWithAlipay/payWithAlipay.js
 **/